// External
import React from 'react';
import { Provider as ReduxProvider } from 'react-redux';
import { NikeDesignSystemProvider } from '@nike/nike-design-system-components';
import { BrowserRouter as Router } from 'react-router-dom';

// Internal
import HomePage from './app/HomePage';
import WithTranslations from './intl/Intl';

import configureStore from './app/store';

const store = configureStore();

const App = () => (
  <ReduxProvider store={store}>
    <NikeDesignSystemProvider>
      <Router>
        <WithTranslations>
          <HomePage />
        </WithTranslations>
      </Router>
    </NikeDesignSystemProvider>
  </ReduxProvider>
);

export default App;
